import type { NodeV2, NodeV2Style } from '@vedalib/editor'
import cn from 'classnames'
import { useCallback } from 'react'
import React from 'react'

import AbsolutePortal from 'components/Editor/components/AbsolutePortal'
import { ABSOLUTE_PORTAL_GAP } from 'components/Editor/components/AbsolutePortal/constants'
import { IconButton } from 'components/uiKit/Button'
import { Tooltip } from 'components/uiKit/Dropdown'
import { KitSize } from 'components/uiKit/KitTypes'
import { updateBlock } from 'services/Store/Project/actions'
import { useProjectDispatch } from 'services/Store/Project/hooks'
import { addGroupItem } from 'services/Store/Project/mutators/node'
import type { Block, IBlockMode } from 'services/Store/Project/types'
import { t } from 'services/Translation'

import * as s from './Controls.module.scss'

interface INodeV2RepeatableProps {
  block: Block
  node: NodeV2
  styles: NodeV2Style | null
  mode: IBlockMode
}

const NodeV2Repeatable: React.FC<INodeV2RepeatableProps> = ({ block, styles, node, mode }) => {
  const dispatch = useProjectDispatch()

  const handleCloneItem = useCallback(
    () =>
      dispatch(updateBlock({ id: block.uuid, value: addGroupItem(node, mode.deviceMode)(block) })),
    [dispatch, block, node, mode.deviceMode],
  )

  return (
    <AbsolutePortal
      chain='horizontal'
      name='zIndex'
      offset={`${ABSOLUTE_PORTAL_GAP}px 0`}
      placement='bottomLeft'
    >
      <div className={cn(s.add, s[styles?.display || 'element'])}>
        <Tooltip mouseEnterDelay={0.5} overlay={t('editorV2.addRepeatableItem')}>
          <IconButton
            disabled={!node.children.length}
            icon='otherCopy'
            name='decrement'
            onClick={handleCloneItem}
            size={KitSize.XS}
            styleType='ghost'
            inheritColor
          />
        </Tooltip>
      </div>
    </AbsolutePortal>
  )
}

export default React.memo(NodeV2Repeatable)
